import { Css, ScrollableParent } from "@homebound/beam";
import { Outlet } from "react-router-dom";

/**
 * Gray scroll frame for standard library-style pages.
 *
 * Role: data router pathless layout. Nest under a domain `RouteObject` in `src/routing/domains/*.ts`.
 * See DESIGN.md "Chrome wrappers".
 */
export function ScrollableParentLayout() {
  return (
    <ScrollableParent px={3} xss={Css.fg1.bgGray100.$}>
      <Outlet />
    </ScrollableParent>
  );
}
